export default "__VITE_PUBLIC_ASSET__3ae33329__"